<template>
  <div>
    <AlertComponent
      v-if="showLiveAuctioneersMessage"
      :title="liveAuctioneersAlertTitle"
      :message="liveAuctioneersAlertMessage"
      @close="showLiveAuctioneersMessage = false"
    />
    
    <a
      class="colorBlack navLink u-full-width"
      @click="showInvoice(invoice_id)"
    >
      <div class="dropdownLeadImageContainer">
        <img v-lazy="invoice.card.image">
      </div>
      <div class="u-full-width">
        <div v-html="invoice.card.title" />
        <div
          v-show="collectionNeeded && hasTrackingInfo === undefined"
          class="textRight colorError"
        >
          <i class="fa fa-exclamation-circle" />
          <small>Property Remains Onsite</small>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import apiMixin from '@/mixins/apiMixin.js'
import * as menuConstants from '@/constants/menu'
import AlertComponent from '@/components/Shared/AlertComponent.vue'

export default {
	name: 'ListCard',
	components: {
		AlertComponent
	},
	mixins: [apiMixin],
	props: [
		'invoice_id'
	],
	data () {
		return {
			showLiveAuctioneersMessage: false,
			liveAuctioneersAlertTitle: 'Complete Purchase on LiveAuctioneers',
			liveAuctioneersAlertMessage: 'This purchase was made through the LiveAuctioneers bidding platform. All payment and shipping arrangements must be completed directly through your LiveAuctioneers account. Please log in to LiveAuctioneers to manage your transaction. Thank you for your understanding.'
		}
	},
	computed: {
		/**
		 * Computed property: All customer invoices
		 * @public
		 */
		invoices: function () {
			return this.$store.getters.invoices
		},
		/**
		 * Computed property: The current invoice object
		 * @public
		 */
		invoice: function () {
			return this.invoices['INVOICEID_' + this.invoice_id]
		},
		/**
		 * Computed property: Whether invoice has inventory onsite
		 * @public
		 */
		collectionNeeded: function () {
			// Check if items still in building
			const itemsInBuilding = this.invoice.invoice_items.reduce((acc, curr) => {
				if (this.isItemInBuilding(curr) === true) {
					acc.push(curr)
				}
				return acc
			}, [])
			return this.invoice.paid_in_full === 'y' && itemsInBuilding.length > 0
		},
		/**
		 * Computed property: Whether invoice has shipping order
		 * @public
		 */
		hasTrackingInfo: function () {
			// In order to view tracking, invoice needs to have a shipping charge line item, paid in full, and a valid arta_shipment_id
			if (this.invoice.invoice_items.find(x => x.shipping_charge === 'y') && this.invoice.paid_in_full === 'y') {
				const shipment = this.invoice.invoice_items.reduce((acc, curr) => {
					if (curr.arta_shipment_id !== null && curr.arta_shipment_id !== undefined) {
						acc.push(curr)
					}
					return acc
				}, [])

				if (shipment !== undefined && shipment.length > 0) {
					return shipment[0].arta_shipment_id
				}
			}
			return undefined
		}
	},
	methods: {
		/**
		 * Gets called when user clicks invoice in list
		 * @param {*} payload
		 * @public
		 */
		showInvoice (payload) {
			if (this.invoice.paid_in_full === 'y' && (this.collectionNeeded === false || this.hasTrackingInfo)) {
				// If invoice has been marked paid_in_full, shouldn't go to the checkout, everything should be paid for
				this.$store.dispatch('updateCurrentInvoice', payload)
				this.insertAccountMenu(menuConstants.MENU_ITEM_INVOICE_ITEM)
				window.location.hash = menuConstants.URL_HASH_INVOICE_ITEM
			} else {
				// Check if this is a NEW LiveAuctioneers invoice (source = 1 AND has marketplace_id)
				if (this.invoice.source === 1 && this.invoice.marketplace_id) {
					// Show status banner message
					this.showLiveAuctioneersMessage = true;
					return;
				}
				this.$store.dispatch('updateCurrentInvoice', payload)
				// Set our current location as an exit-referrer in localstorage for all of the exit buttons.
				localStorage.setItem('exit-referrer', window.location.href)
				window.location = `${this.getUrlHost(this.$store.getters.apiPath)}/checkout/${payload}`
			}
		},
		/**
		 * Gets called by showInvoice
		 * @param {*} payload
		 */
		insertAccountMenu (payload) {
			this.$store.dispatch('insertAccountHistory', payload)
		},
		/**
		 * Gets called by collectionNeeded property
		 *
		 * @param {*} item
		 */
		isItemInBuilding (item) {
			return item.shipping_charge === 'n' &&
				(item.automobile_charge === 'n' || item.automobile_charge === null) &&
				(item.packaging_charge === 'n' || item.packaging_charge === null) &&
				item.has_left_building !== 'y' &&
				item.total_charges > 0 &&
				item.inventory_id > 0
		}
	}
}

</script>

<style scoped></style>
